(function($) {
    var documentLoad = function() {
        if ($('#wpadminbar').length == 1) {
            $('.module[data-editor-module-id]').each(function() {
                var moduleElement = this;
                var moduleId = $(moduleElement).attr('data-editor-module-id');
                var moduleType = $(moduleElement).attr('data-editor-module-type');
                $(moduleElement).append(
                    '<div class="admin-editor-link">' +
                    '<a class="module-edit-link" href="/wp-admin/post.php?post=' + moduleId + '&action=edit" target="_blank"><h4>Click Here To Edit Module Above &gt;</h4></a>' +
                    '<a class="module-list-link" href="/wp-admin/edit.php?post_type=' + moduleType + '" target="_blank"><p>View All Modules Of This Type &gt;</p></a>' +
                    '</div>'
                );
            });
        }
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/admin.js